(function () {
    var rail = document.querySelector('.sov-ugc-rail');
    var inner = rail ? rail.querySelector('.sov-ugc-rail__inner') : null;

    // shuffle delle immagini e ricostruzione con doppia sequenza per loop infinito
    if (inner) {
      var allItems = Array.prototype.slice.call(inner.querySelectorAll('.sov-ugc-rail__item'));

      if (allItems.length > 0) {
        var baseItems = allItems.slice();

        // fisher-yates shuffle
        for (var i = baseItems.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = baseItems[i];
          baseItems[i] = baseItems[j];
          baseItems[j] = tmp;
        }

        // svuota il contenitore
        while (inner.firstChild) {
          inner.removeChild(inner.firstChild);
        }

        // prima sequenza shufflata
        baseItems.forEach(function (item) {
          inner.appendChild(item);
        });

        // seconda sequenza identica per lo scroll infinito
        baseItems.forEach(function (item) {
          inner.appendChild(item.cloneNode(true));
        });
      }
    }

    // lightbox
    var lightbox = document.querySelector('.sov-ugc-lightbox');
    var img;
    var overlay;
    var closeBtn;

    if (lightbox) {
      if (lightbox.parentNode !== document.body) {
        document.body.appendChild(lightbox);
      }

      img = lightbox.querySelector('.sov-ugc-lightbox__img');
      overlay = lightbox.querySelector('.sov-ugc-lightbox__overlay');
      closeBtn = lightbox.querySelector('.sov-ugc-lightbox__close');

      function openLightbox(src) {
        if (!img) {
          return;
        }

        img.src = src;
        lightbox.hidden = false;
        document.body.classList.add('ugc-lightbox-open');

        if (window.gtag) {
          window.gtag('event', 'pdp_ugc_image_click', {
            event_category: 'UGC',
            event_label: src,
          });
        }
      }

      function closeLightbox() {
        lightbox.hidden = true;
        document.body.classList.remove('ugc-lightbox-open');

        if (img) {
          img.src = '';
        }

        if (window.gtag) {
          window.gtag('event', 'pdp_ugc_lightbox_close', {
            event_category: 'UGC',
          });
        }
      }

      var items = document.querySelectorAll('.sov-ugc-rail__item');
      items.forEach(function (el) {
        el.addEventListener('click', function () {
          var src = el.getAttribute('data-ugc-image');
          if (src) {
            openLightbox(src);
          }
        });
      });

      if (overlay) {
        overlay.addEventListener('click', closeLightbox);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closeLightbox);
      }

      if (img) {
        img.addEventListener('click', closeLightbox);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) {
          closeLightbox();
        }
      });
    }

    if (!rail || !inner) {
      return;
    }

    // autoscroll infinito + touch drag + wheel
    var offset = 0;
    var speedPerFrame = 0.4;
    var loopWidth = 0;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var lastTime = window.performance ? window.performance.now() : Date.now();

    function recalcLoopWidth() {
      var totalWidth = inner.scrollWidth;
      loopWidth = totalWidth / 2;
    }

    recalcLoopWidth();
    window.addEventListener('resize', recalcLoopWidth);

    function normalizeOffset() {
      if (loopWidth <= 0) {
        return;
      }

      while (offset >= loopWidth) {
        offset -= loopWidth;
      }

      while (offset < 0) {
        offset += loopWidth;
      }
    }

    function applyTransform() {
      inner.style.transform = 'translateX(' + -offset + 'px)';
    }

    // solo touch drag (mobile), niente drag con mouse
    rail.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length === 0) {
          return;
        }

        isDragging = true;
        dragStartX = e.touches[0].clientX;
        dragStartOffset = offset;
      },
      { passive: true }
    );

    rail.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging || !e.touches || e.touches.length === 0) {
          return;
        }

        var delta = e.touches[0].clientX - dragStartX;
        offset = dragStartOffset - delta;
        normalizeOffset();
        applyTransform();
      },
      { passive: true }
    );

    rail.addEventListener('touchend', function () {
      isDragging = false;
    });

    // wheel → scroll orizzontale
    rail.addEventListener(
      'wheel',
      function (e) {
        var delta;

        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          delta = e.deltaY;
        } else {
          delta = e.deltaX;
        }

        offset += delta;
        normalizeOffset();
        applyTransform();
        e.preventDefault();
      },
      { passive: false }
    );

    function step(timestamp) {
      var now = typeof timestamp === 'number' ? timestamp : Date.now();
      var deltaTime = now - lastTime;
      lastTime = now;

      if (!isDragging && loopWidth > 0) {
        var framesApprox = deltaTime / 16.7;
        offset += speedPerFrame * framesApprox;
        normalizeOffset();
        applyTransform();
      }

      window.requestAnimationFrame(step);
    }

    applyTransform();
    window.requestAnimationFrame(step);
  })();